import { TableContainer, Table, TableBody, TableRow, TableCell, Typography } from "@mui/material";
import { WorkshopProduct } from '../../types/WorkshopProducts';
import { WorkshopProductCombination } from '../../types/WorkshopProductCombination';
import { Product } from '../../types/Product';
import { Company } from '../../types/Company';
import { Interface } from '../../types/Interface';

export const TestingInfoTable = ({ client, server, iface, companies }:
    { client?: [Product, WorkshopProduct, WorkshopProductCombination], server?: [Product, WorkshopProduct, WorkshopProductCombination], companies?: Company[], iface?: Interface }) => {

    let clientStr = 'Please select a client product!';
    let serverStr = 'Please select a server product!';

    if (client) {
        const clientCompanyName = `${companies?.find(company => company.id === client[0].companyId)?.name}`;
        clientStr = `${clientCompanyName} - ${client[0].name} ${client[1]?.productVersion ?? ""}`;
    }
    if (server) {
        const serverCompanyName = companies?.find(company => company.id === server[0].companyId)?.name;
        serverStr = `${serverCompanyName} - ${server[0].name} ${server[1].productVersion ?? ""}`;
    }

    return <TableContainer>
        <Table>
            <TableBody>
                <TableRow>
                    <TableCell><Typography variant={'bold'}>Client</Typography></TableCell>
                    <TableCell>{(clientStr)}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell><Typography variant={'bold'}>Server</Typography></TableCell>
                    <TableCell>{serverStr}</TableCell>
                </TableRow>
                <TableCell><Typography variant={'bold'}>Interface</Typography></TableCell>
                <TableCell>{iface?.name ?? ""}</TableCell>
            </TableBody>
        </Table>
    </TableContainer>
}